import type { FrontendApi } from "@ory/client-fetch";

import { createOryClient } from "@mountayaapp/auth";

import { requireOrySdkUrl } from "../../env";

/**
 * orySdkUrl is the build-time Ory SDK URL (VITE_ORY_SDK_URL, inlined by Vite).
 * requireOrySdkUrl throws loudly at module load if it is unset, so a forgotten
 * VITE_ORY_SDK_URL is caught at boot rather than at first auth.
 */
const orySdkUrl = requireOrySdkUrl();

/**
 * ory is the configured FrontendApi singleton for the SPA, built from the
 * build-time env. credentials: "include" (set inside createOryClient) attaches
 * the ory_session_* cookie on every request. The render-free engine and the
 * session bootstrap both receive this instance from the app tier.
 */
export const ory: FrontendApi = createOryClient({ sdkUrl: orySdkUrl });

/**
 * ORY_SDK_URL is the resolved Ory SDK URL, re-exported for the few call sites
 * that build a browser-endpoint URL directly (logout, re-auth redirects).
 */
export const ORY_SDK_URL = orySdkUrl;
